import { render, staticRenderFns } from "./ResellerDetails.vue?vue&type=template&id=2f732ed3&scoped=true"
import script from "./ResellerDetails.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ResellerDetails.vue?vue&type=script&charset=utf-8&lang=js"
import style0 from "./ResellerDetails.vue?vue&type=style&index=0&id=2f732ed3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f732ed3",
  null
  
)

export default component.exports